(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-collection-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-category-navigation')) {
  customElements.define('cc-category-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const reveal = () => requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const list = this.querySelector('ul');
        const active = this.querySelector('[aria-current="page"]');
        if (!list || !active || list.scrollWidth <= list.clientWidth) return;
        list.scrollLeft += active.getBoundingClientRect().left - list.getBoundingClientRect().left - (list.clientWidth - active.offsetWidth) / 2;
      });
      reveal();
      document.fonts?.ready.then(reveal);
      window.addEventListener('resize', reveal, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-shop-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-shop-menu')) {
  customElements.define('cc-shop-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      const panel = this.querySelector('.cc-shop-menu__panel');
      const desktop = !this.classList.contains('cc-shop-menu--mobile');
      const blendedHeader = desktop ? this.closest('[data-homepage-blended]') : null;
      this.blendedHeader = blendedHeader;
      let expanded = details.open;
      const setOpen = (open) => {
        clearTimeout(this.closeTimer);
        if (expanded === open) return;
        expanded = open;
        const wasOpen = details.open;
        const current = getComputedStyle(panel);
        const start = wasOpen
          ? { opacity: current.opacity, transform: current.transform }
          : { opacity: 0, transform: 'translateY(-8px)' };
        this.animation?.cancel();
        blendedHeader?.classList.toggle('cc-menu-closing', !open);
        if (desktop) {
          summary.setAttribute('aria-expanded', String(open));
          panel.inert = !open;
        }
        if (!desktop || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          details.open = open;
          blendedHeader?.classList.remove('cc-menu-closing');
          return;
        }
        details.open = true;
        const animation = panel.animate([
          start,
          { opacity: open ? 1 : 0, transform: open ? 'translateY(0)' : 'translateY(-8px)' }
        ], {
          duration: open ? 220 : 180,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          fill: 'both'
        });
        this.animation = animation;
        animation.onfinish = () => {
          if (this.animation !== animation) return;
          details.open = open;
          blendedHeader?.classList.remove('cc-menu-closing');
          animation.cancel();
          this.animation = null;
        };
      };
      const close = () => setOpen(false);
      if (desktop) {
        summary.setAttribute('aria-expanded', String(expanded));
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          setOpen(!expanded);
        }, options);
      } else {
        details.addEventListener('toggle', () => { expanded = details.open; }, options);
      }
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.stopPropagation();
          close();
          summary.focus();
        }
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) close();
      }, options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) close();
      }, options);
      if (desktop) {
        this.addEventListener('pointerenter', (event) => {
          clearTimeout(this.closeTimer);
          if (event.pointerType === 'mouse') setOpen(true);
        }, options);
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse' && !this.contains(document.activeElement)) {
            this.closeTimer = setTimeout(close, blendedHeader ? 60 : 180);
          }
        }, options);
        window.addEventListener('resize', close, options);
      }
    }
    disconnectedCallback() { this.blendedHeader?.classList.remove('cc-menu-closing'); clearTimeout(this.closeTimer); this.animation?.cancel(); this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["region-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  document.querySelectorAll('.cc-header-region .cc-region-selector__disclosure[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.cc-header-region .cc-region-selector__disclosure[open]').forEach((details) => {
    details.open = false;
    details.querySelector('summary').focus();
  });
});
  } catch(e) { console.error(e); }
})();

})();
